export default "__VITE_ASSET__9VAyzJV1__"